module.exports = __webpack_public_path__ + "img/DSC02320.aacf06a9.jpg";